import React from 'react';
import { Vimeo as VimeoUI } from '@invertase/ui';

type VideoId =
  | 'android-large-icon'
  | 'android-badge'
  | 'android-importance-high'
  | 'android-importance-default'
  | 'android-importance-low'
  | 'android-importance-minimum'
  | 'android-color'
  | 'android-ongoing'
  | 'android-actions-showcase'
  | 'android-actions-pending'
  | 'android-small-icon'
  | 'android-style-bigpicture'
  | 'android-style-bigtext'
  | 'android-style-messaging'
  | 'android-style-inbox'
  | 'android-text-style'
  | 'android-progress-summary'
  | 'android-progress-update'
  | 'android-grouped'
  | 'android-chronometer-down'
  | 'android-chronometer'
  | 'android-timestamp'
  | 'android-foreground-service'
  | 'ios-attachments'
  | 'ios-summary-text'
  | 'ios-request-permission'
  | 'ios-provisional-setting'
  | 'ios-category-actions'
  | 'ios-action-destructive'
  | 'ios-action-input'
  | 'ios-importance-high'
  | 'ios-importance-default'
  | 'triggers-example'
  | 'android-battery-optimization';

const videos: { [key in VideoId]: number } = {
  'android-large-icon': 385469894,
  'android-badge': 385469776,
  'android-importance-high': 385469824,
  'android-importance-default': 385469803,
  'android-importance-low': 385469853,
  'android-importance-minimum': 385469873,
  'android-color': 385469788,
  'android-ongoing': 385475992,
  'android-actions-showcase': 385481038,
  'android-actions-pending': 386680747,
  'android-small-icon': 435859310,
  'android-style-bigpicture': 385504344,
  'android-style-bigtext': 385509335,
  'android-style-messaging': 385940932,
  'android-style-inbox': 385939542,
  'android-text-style': 385936255,
  'android-progress-summary': 385943329,
  'android-progress-update': 385945478,
  'android-grouped': 385950479,
  'android-chronometer-down': 385959392,
  'android-chronometer': 385959405,
  'android-timestamp': 385959413,
  'android-foreground-service': 386254150,
  'ios-attachments': 435859031,
  'ios-summary-text': 445185906,
  'ios-request-permission': 402244797,
  'ios-provisional-setting': 402244732,
  'ios-category-actions': 402244609,
  'ios-action-destructive': 402244498,
  'ios-action-input': 402244554,
  'ios-importance-high': 402244686,
  'ios-importance-default': 402244647,
  'triggers-example': 445346021,
  'android-battery-optimization': 459004081,
};

interface Props {
  id: string;
  caption?: string;
  width?: number;
}

function Vimeo({ id, caption, width }: Props) {
  // @ts-ignore
  const vimeoId = videos[id];

  if (!vimeoId) {
    return null;
  }

  return <VimeoUI id={vimeoId} caption={caption} width={width} />;
}

export default Vimeo;
